(function(){
  document.querySelector('.qtyplus-product1').addEventListener('click', (event) => {
    document.querySelector('.qty-product1').value = parseInt(document.querySelector('.qty-product1').value) + 1
  })
  document.querySelector('.qtyminus-product1').addEventListener('click', (event) => {
      if(parseInt(document.querySelector('.qty-product1').value) > 1){
          document.querySelector('.qty-product1').value = parseInt(document.querySelector('.qty-product1').value) - 1
      }
  })
  
  document.querySelector('.qtyplus-product2').addEventListener('click', (event) => {
      document.querySelector('.qty-product2').value = parseInt(document.querySelector('.qty-product2').value) + 1
  })
  document.querySelector('.qtyminus-product2').addEventListener('click', (event) => {
      if(parseInt(document.querySelector('.qty-product2').value) > 1){
          document.querySelector('.qty-product2').value = parseInt(document.querySelector('.qty-product2').value) - 1
      }
  })
  
  document.querySelector('.fit-quiz-response-product__atc.product1').addEventListener('click', () => {
      let formData = {
       'items': [{
        'id': parseInt(document.querySelector('.fit-quiz-response-product__atc.product1').dataset.productid),
        'quantity': parseInt(document.querySelector('.qty-product1').value)
        }]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if(response.status == 200){
            document.querySelector('.fit-quiz-response-product__atc.product1').textContent = "Added"
            document.querySelector('.fit-quiz-response-product__atc.product1').disabled = true
            setTimeout(() => {
                document.querySelector('.fit-quiz-response-product__atc.product1').textContent = "Add to Cart"
                document.querySelector('.fit-quiz-response-product__atc.product1').disabled = false
            }, 2000)
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  })
  
  document.querySelector('.fit-quiz-response-product__atc.product2').addEventListener('click', () => {
      let formData = {
       'items': [{
        'id': parseInt(document.querySelector('.fit-quiz-response-product__atc.product2').dataset.productid),
        'quantity': parseInt(document.querySelector('.qty-product2').value)
        }]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if(response.status == 200){
            document.querySelector('.fit-quiz-response-product__atc.product2').textContent = "Added"
            document.querySelector('.fit-quiz-response-product__atc.product2').disabled = true
            setTimeout(() => {
                document.querySelector('.fit-quiz-response-product__atc.product2').textContent = "Add to Cart"
                document.querySelector('.fit-quiz-response-product__atc.product2').disabled = false
            }, 2000)
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  })
})()